import useAppStore from '@/store/app';
import { Logo } from '@/UI/Logo';
import clsx from 'clsx';
import { Link } from 'react-router-dom';

export const Navbar = () => {
  const { toggleDrawer, isOpenDrawer } = useAppStore();

  return (
    <div className="relative z-50 h-16 md:hidden">
      <div
        className={clsx(
          'navbar fixed left-0 top-0 z-10 bg-card md:hidden',
          !isOpenDrawer && 'shadow-header'
        )}
      >
        <Link className="flex-1" to="/">
          <Logo />
        </Link>
        <div className="flex-none">
          <button className="btn btn-square btn-ghost" onClick={toggleDrawer}>
            <div className="swap">
              <input type="checkbox" readOnly checked={isOpenDrawer} />
              <img className="swap-off" src="/icons/burger.webp" alt="burger" />
              <img className="swap-on" src="/icons/close.webp" alt="close" />
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};
